import { SEOHead } from '@components/seo';
import { SuggestionEmail } from '@screens/suggestions';

export default function SuggestionsComplaiments() {
  return (
    <>
      <SEOHead title="Meki · Sugerencias y Reclamos" />
      <SuggestionEmail />
    </>
  );
}
